require("./application.js");
require("../tenants/hku/custom-timetable.js");
